<div class="confirm-dialog-wrapper">
  <div *ngIf="hideUpload">
    <h6 *ngIf="uploadedDocuments?.length" class="mt-4 file-heading">Uploaded Files</h6>
    <div *ngIf="uploadedDocuments?.length" class="wrapper-class-uploadfiles">
      <div *ngFor="let uploadedFile of uploadedDocuments;let index = index;" class="row dialog-row mt-0">
        <div class="col-md-1 col-1 m-auto">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="40" height="40" rx="20" fill="white" />
            <path
              d="M28.3346 18.3346V22.5013C28.3346 26.668 26.668 28.3346 22.5013 28.3346H17.5013C13.3346 28.3346 11.668 26.668 11.668 22.5013V17.5013C11.668 13.3346 13.3346 11.668 17.5013 11.668H21.668"
              stroke="#4F6681"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28.3346 18.3346H25.0013C22.5013 18.3346 21.668 17.5013 21.668 15.0013V11.668L28.3346 18.3346Z"
              stroke="#4F6681"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.832 20.832H20.832"
              stroke="#4F6681"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.832 24.168H19.1654"
              stroke="#4F6681"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="col-md-10 col-8 m-auto doc-name-uploaded-file">
          <h6 class="pb-0 doc-name">
              <a href="{{uploadedFile.fileUrl}}" download="{{uploadedFile.fileName}}">
                  {{uploadedFile.fileName}}
              </a>
          </h6>
          <p class="mb-0 doc-description">Document Uploaded</p>
      </div>
      <div class="col-md-1 col-1 m-auto" (click)="removeFile(uploadedFile.documentId!)">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="31"
            height="31"
            rx="3.5"
            stroke="#4F6681"
            stroke-opacity="0.2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4987 10.5C18.9129 10.5 19.2487 10.1642 19.2487 9.75C19.2487 9.33579 18.9129 9 18.4987 9H13.4987C13.0845 9 12.7487 9.33579 12.7487 9.75C12.7487 10.1642 13.0845 10.5 13.4987 10.5L18.4987 10.5ZM9.33203 12.5833H9.44103L10.1372 22.0111L10.1373 22.0117C10.2315 23.2735 11.2822 24.25 12.5477 24.25H19.4477C20.7155 24.25 21.7677 23.2699 21.8583 22.0053L21.8583 22.0051L22.531 12.5833H22.6654C23.0796 12.5833 23.4154 12.2475 23.4154 11.8333C23.4154 11.4191 23.0796 11.0833 22.6654 11.0833H21.8339L21.8327 11.0833H10.1377L10.137 11.0833H9.33203C8.91782 11.0833 8.58203 11.4191 8.58203 11.8333C8.58203 12.2475 8.91782 12.5833 9.33203 12.5833ZM11.6331 21.9L10.9451 12.5833H21.0272L20.3621 21.8981C20.3277 22.3784 19.9282 22.75 19.4477 22.75H12.5477C12.0683 22.75 11.6691 22.38 11.6331 21.9003L11.6331 21.9ZM18.4154 16C18.4154 15.5858 18.0796 15.25 17.6654 15.25C17.2511 15.25 16.9154 15.5858 16.9154 16V19.3333C16.9154 19.7475 17.2511 20.0833 17.6654 20.0833C18.0796 20.0833 18.4154 19.7475 18.4154 19.3333V16ZM14.7487 15.25C15.1629 15.25 15.4987 15.5858 15.4987 16V19.3333C15.4987 19.7475 15.1629 20.0833 14.7487 20.0833C14.3345 20.0833 13.9987 19.7475 13.9987 19.3333V16C13.9987 15.5858 14.3345 15.25 14.7487 15.25Z"
            fill="#4F6681"
          />
        </svg>
      </div>
      </div>
    </div>
  </div>
  <div *ngIf="!hideUpload" class="confirm-dialog">
    <button type="button" class="btn btn-link modal-close" (click)="onCancel()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18"
          stroke="#03101F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="#03101F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <!-- Upload File-->
    <div>
      <img src="../../../assets/images/file-upload.svg" alt="file" />
    </div>
    <button
      class="btn theme-btn px-2 ms-3 border-sm-0"
      mat-raised-button
      color="primary"
      (click)="onUpload($event)"
    >
      Upload
    </button>
  </div>
  <h6 *ngIf="uploadedFiles?.length" class="mt-4 file-heading">Uploaded Files</h6>
  <div *ngIf="uploadedFiles?.length" class="wrapper-class-uploadfiles">
    <div *ngFor="let uploadedFile of uploadedFiles;let index = index;" class="row dialog-row mt-0">
      <div class="col-md-1 col-1 m-auto">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" rx="20" fill="white" />
          <path
            d="M28.3346 18.3346V22.5013C28.3346 26.668 26.668 28.3346 22.5013 28.3346H17.5013C13.3346 28.3346 11.668 26.668 11.668 22.5013V17.5013C11.668 13.3346 13.3346 11.668 17.5013 11.668H21.668"
            stroke="#4F6681"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.3346 18.3346H25.0013C22.5013 18.3346 21.668 17.5013 21.668 15.0013V11.668L28.3346 18.3346Z"
            stroke="#4F6681"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.832 20.832H20.832"
            stroke="#4F6681"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.832 24.168H19.1654"
            stroke="#4F6681"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="col-md-10 col-8 m-auto">
        <h6 class="pb-0 doc-name">{{uploadedFile.name}}</h6>
        <p class="mb-0 doc-description">Document Uploaded</p>
      </div>
      <div class="col-md-1 col-1 m-auto" *ngIf="!hideUpload" (click)="removeItem(index)">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="31"
            height="31"
            rx="3.5"
            stroke="#4F6681"
            stroke-opacity="0.2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4987 10.5C18.9129 10.5 19.2487 10.1642 19.2487 9.75C19.2487 9.33579 18.9129 9 18.4987 9H13.4987C13.0845 9 12.7487 9.33579 12.7487 9.75C12.7487 10.1642 13.0845 10.5 13.4987 10.5L18.4987 10.5ZM9.33203 12.5833H9.44103L10.1372 22.0111L10.1373 22.0117C10.2315 23.2735 11.2822 24.25 12.5477 24.25H19.4477C20.7155 24.25 21.7677 23.2699 21.8583 22.0053L21.8583 22.0051L22.531 12.5833H22.6654C23.0796 12.5833 23.4154 12.2475 23.4154 11.8333C23.4154 11.4191 23.0796 11.0833 22.6654 11.0833H21.8339L21.8327 11.0833H10.1377L10.137 11.0833H9.33203C8.91782 11.0833 8.58203 11.4191 8.58203 11.8333C8.58203 12.2475 8.91782 12.5833 9.33203 12.5833ZM11.6331 21.9L10.9451 12.5833H21.0272L20.3621 21.8981C20.3277 22.3784 19.9282 22.75 19.4477 22.75H12.5477C12.0683 22.75 11.6691 22.38 11.6331 21.9003L11.6331 21.9ZM18.4154 16C18.4154 15.5858 18.0796 15.25 17.6654 15.25C17.2511 15.25 16.9154 15.5858 16.9154 16V19.3333C16.9154 19.7475 17.2511 20.0833 17.6654 20.0833C18.0796 20.0833 18.4154 19.7475 18.4154 19.3333V16ZM14.7487 15.25C15.1629 15.25 15.4987 15.5858 15.4987 16V19.3333C15.4987 19.7475 15.1629 20.0833 14.7487 20.0833C14.3345 20.0833 13.9987 19.7475 13.9987 19.3333V16C13.9987 15.5858 14.3345 15.25 14.7487 15.25Z"
            fill="#4F6681"
          />
        </svg>
      </div>
    </div>
  </div>
  <button
  class="btn theme-btn px-2 ms-3 mt-3 border-sm-0 float-end"
  mat-raised-button
  color="primary"
  (click)="onCancel()">
  Close
</button>
</div>
